<template>
  <div>
    <el-page-header @back="goback" content="消息通知详情"> </el-page-header>
    <h2 style="text-align: center">{{ article.title }}</h2>
    <div v-html="article.content"></div>
    <div>
      <div style="margin-right: 50px; text-align: right">
        {{ article.createTime }}
      </div>
    </div>
  </div>
</template>
<script>
import NewsApi from '../apis/news'
export default {
  data () {
    return {
      article: null
    }
  },
  methods: {
    goback () {
      this.$router.go(-1)
    }
  },
  mounted () {
    var id = this.$route.query.id
    NewsApi.get({ id: id }).then(res => {
      this.article = res.result
    })

  }
}
</script>


// WEBPACK FOOTER //
// src/views/newsDetail.vue